import React, { useState } from "react"

import "@draft-js-plugins/static-toolbar/lib/plugin.css"

import { BoldButton, OrderedListButton, UnorderedListButton } from "@draft-js-plugins/buttons"
import Editor from "@draft-js-plugins/editor"
import createToolbarPlugin from "@draft-js-plugins/static-toolbar"
import { ContentState, convertFromHTML, convertToRaw, EditorState } from "draft-js"
import draftToHtml from "draftjs-to-html"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"
import { textHTMLStyles } from "ui/components/atoms/text-html"
import { BaseStyles } from "ui/types/base-styles"

const RichTextEditor = ({
  name,
  value = "",
  onChange,
  ...rest
}: BaseStyles & {
  name: string
  value?: string
  onChange: (event: { target: { name: string; value: string } }) => void
}) => {
  const [{ plugins, Toolbar }] = useState(() => {
    const toolbarPlugin = createToolbarPlugin()
    const { Toolbar } = toolbarPlugin
    const plugins = [toolbarPlugin]
    return {
      plugins,
      Toolbar,
    }
  })

  const blocksFromHTML = convertFromHTML(value)
  const contentState = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap,
  )

  const [state, setState] = useState(EditorState.createWithContent(contentState))

  const handleOnChange = (txt: any) => {
    setState(txt)
    onChange({
      target: {
        name,
        value: draftToHtml(convertToRaw(txt.getCurrentContent())),
      },
    })
  }

  return (
    <Wrapper {...rest}>
      <ToolbarWrapper>
        <Toolbar>
          {externalProps => (
            <div>
              <BoldButton {...externalProps} />
              <UnorderedListButton {...externalProps} />
              <OrderedListButton {...externalProps} />
            </div>
          )}
        </Toolbar>
      </ToolbarWrapper>
      <EditorWrapper $marginTop="XS">
        <Editor editorState={state} onChange={handleOnChange} plugins={plugins} />
      </EditorWrapper>
    </Wrapper>
  )
}

export default RichTextEditor

const EditorWrapper = styled(Box)`
  ${textHTMLStyles};
  margin-top: ${({ theme }) => theme.space.XS};

  .public-DraftEditor-content {
    min-height: 150px !important;
  }
`

const ToolbarWrapper = styled(Box)`
  > div {
    border-radius: ${({ theme }) => theme.variable.borderRadius};
    border: 1px solid ${({ theme }) => theme.color.border};
    box-shadow: none;
    overflow: hidden;

    button {
      background: none;

      &:hover {
        background: ${({ theme }) => theme.color.background};
      }
    }
  }
`

const Wrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.XS};
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  border: 1px solid ${({ theme }) => theme.color.border};
`
